<template>
    <div style="width:100%;">
        <b-container>
            <b-row>
                <b-col :cols="desktop ? '3' : doctors.length" v-for="doctor in doctors" :key="doctor.id"  style="margin:1rem">
                <b-card 
                :title="doctor.employee.lastName + ' ' + doctor.employee.firstName + ' ' + doctor.employee.middleName"
                img-alt="Image"
                img-top
                tag="article"
                style="max-width: 20rem; min-width:18rem;"
                class="mb-2 swiper-slide"
            >
            <template #header>
                <img v-if="doctor.employee.avatar" :src="doctor.employee.avatar" style="max-width:100%; border-radius: 50%; height:250px"/>
                <template v-else>
                    <photo style="width:100%; height:250px; color:gray" />
                </template>
            </template>
                <b-card-text>
                    {{doctor.specialty.title}} <template v-if="doctor.experience">, стаж {{plural(doctor.experience, 'год', 'года', 'лет')}}. </template> <template v-else>.</template>
                </b-card-text>

                <b-button @click="$router.push({name: 'currentSpecialist', params: {id: doctor.id}})" variant="primary">Подробнее</b-button>
            </b-card>
                    
                </b-col>
            </b-row>
        </b-container>
        <template v-if="loading">
        <b-container>
            <b-row>
                <b-col cols="3" v-for="i in 3" :key="i"  style="margin:1rem">
                <b-skeleton-img height="350px" width="18rem"
                class="mb-2"
            >
           

            </b-skeleton-img>
                    
                </b-col>
            </b-row>
        </b-container>
      </template>
        <!--CurrentSpecialist v-if="current_specialist" :doctor="current_specialist" /-->
        <!--router-view></router-view-->
    </div>    
</template>

<script>
import { doctorApi } from '@app/services';
import photo from '@app/assets/icons/camera.svg?inline';
 
export default {
    components: {
        photo,
    },
    data() {
        return {
            desktop: null,
            doctors: [],
            current_specialist: null,
            loading: false
        };
    },
    created() {
        window.addEventListener('resize', this.resizeHandler);
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeHandler);
    },
    mounted() {
        this.loading = true;
        doctorApi.getAll().then(res => {
            if(this.$store.state.navigation.site === 'kardioservis.ru') {
                this.doctors = [ res.items.find(o => o.employee.lastName === 'Загирова'), 
                res.items.find(o => o.employee.lastName === 'Минуллина'),
                res.items.find(o => o.employee.lastName === 'Фасхутдинова'),
                res.items.find(o => o.employee.lastName === 'Ахметшина'),
                res.items.find(o => o.employee.lastName === 'Загиров'),
                res.items.find(o => o.employee.lastName === 'Галиева'),
                res.items.find(o => o.employee.lastName === 'Хакимова'),
                res.items.find(o => o.employee.lastName === 'Юсупова'),
                res.items.find(o => o.employee.lastName === 'Фахретдинова'),
                res.items.find(o => o.employee.lastName === 'Гарифуллина'),
                res.items.find(o => o.employee.lastName === 'Каюмова')
                ];
            } else {
                this.doctors = res.items;
            }
        }).catch(error => {
            console.log(error);
        }).finally(res => {
            this.loading = false;
        });
        this.desktop = window.innerWidth > 1100;
    },
    methods: {
        plural(n,str1,str2,str5) {
            return n + ' ' + ((((n%10)==1)&&((n%100)!=11))?(str1):(((((n%10)>=2)&&((n%10)<=4))&&(((n%100)<10)||((n%100)>=20)))?(str2):(str5)));
        },
        resizeHandler({ target }) {
            const isDesktop = target.innerWidth > 1100;
            let bool;
            if (isDesktop) {
                if (!this.desktop) {
                bool = true;
                }
            } else if (this.desktop) {
                bool = false;
            }
            this.desktop = isDesktop;
        }
    }
    
};
</script>

<style lang="scss" scoped>

</style>